import React from "react";
import { connect } from "react-redux";
import "./ConsoleView.css";

import Combatant from "./ConsoleView/Combatant";
import ConsoleViewRollout from "./ConsoleViewRollout";
import { getCombatantIdFromSelectingString } from "./get-combatant-id-from-selecting-string";

class ConsoleView extends React.Component {
  renderConnectedBotWarning() {
    //This is an edge case check.. but if you are "in your own browser as a Bot", don't send any ViewConfirmation
    if (this.props.isConnectedAsBot) {
      return <div>THIS IS A BOT. YOU ARE A BOT.</div>;
    }
    return null;
  }

  renderMasterStatus() {
    if (this.props.isMultiplayerMasterClient) {
      return <div>MASTER</div>;
    }
    return null;
  }

  render() {
    const {
      combatants,
      combatantSelectingAction,
      teams,
      battlePlayerId,
      serverRoomConnections
    } = this.props;

    if (!serverRoomConnections) {
      return <div>No `connections` object!</div>;
    }

    const useCombId = getCombatantIdFromSelectingString(
      combatantSelectingAction
    );
    return (
      <div>
        {combatantSelectingAction}
        {this.renderMasterStatus()}
        {this.renderConnectedBotWarning()}
        <div className="ConsoleView-columns-container">
          <div className="ConsoleView-main-area">
            <div>
              {teams["two"].combatantIds.map((combId, i) => {
                //TODO `isPlayerControlled` should check an array
                return (
                  <Combatant
                    key={i}
                    model={combatants[combId]}
                    isSelectingAction={useCombId === combId}
                    isPlayerControlled={battlePlayerId.includes(combId)}
                    isConnected={Boolean(serverRoomConnections[combId])}
                  />
                );
              })}
            </div>
            <div>
              {teams["one"].combatantIds.map((combId, i) => {
                return (
                  <Combatant
                    key={i}
                    model={combatants[combId]}
                    isSelectingAction={useCombId === combId}
                    isPlayerControlled={battlePlayerId.includes(combId)}
                    isConnected={Boolean(serverRoomConnections[combId])}
                  />
                );
              })}
            </div>
          </div>
          <div className="ConsoleView-rollout-area">
            {/* Do not let "Browser Bots" have UI or send ViewConfirmations*/}
            {this.props.isConnectedAsBot ? null : <ConsoleViewRollout />}
          </div>
        </div>
      </div>
    );
  }
}

export default connect((state, props) => {
  //const myPlayerCombatantModel = state.battle.combatants[ state.battle.battlePlayerId[0] ]; //Assume just one

  const playersThatAreNowActuallyBots = state.battle.battlePlayerId.filter(
    id => {
      return state.battle.combatants[id] && state.battle.combatants[id].isBot;
    }
  );

  return {
    battlePlayerId: state.battle.battlePlayerId,
    combatantSelectingAction: state.battle.combatantSelectingAction,
    combatants: state.battle.combatants,
    teams: state.battle.teams,
    serverRoomConnections: state.battle.serverRoomConnections,
    isMultiplayerMasterClient: state.battle.isMultiplayerMasterClient,

    /*"Browser Bots": I am the browser of a character who is a Bot. This is an edge case, but might become a problem if coming back from leaving*/
    isConnectedAsBot: playersThatAreNowActuallyBots.length > 0
  };
})(ConsoleView);



// WEBPACK FOOTER //
// ./src/battle/ConsoleView.js